import SiteLayout from "@/components/feature/SiteLayout";
import PageHero from "@/components/feature/PageHero";
import Reveal from "@/components/base/Reveal";
import LocavoreForm from "@/components/feature/LocavoreForm";
import { images } from "@/mocks/site";

const prompts = [
  "A restaurant with a story worth telling",
  "A farm doing quietly remarkable things",
  "A market that feeds a whole neighbourhood",
  "A maker, grower or chef you'd travel for",
  "A food destination tourists miss",
  "A community building a local food economy",
];

export default function SubmitALocavorePage() {
  return (
    <SiteLayout>
      <PageHero
        eyebrow="Bring Eddie · Submit"
        title={
          <>
            KNOW A PLACE
            <br />
            EDDIE SHOULD VISIT?
          </>
        }
        subtitle="Recommend a Locavore business, person, restaurant, farm, market or destination for Eddie to discover on his travels."
        image={images.marketLane}
        imageClassName="object-center"
      />

      <section className="bg-background-50">
        <div className="w-full px-5 md:px-10 lg:px-16 py-20 md:py-28">
          <div className="grid grid-cols-1 gap-12 lg:grid-cols-12 lg:gap-16">
            <div className="lg:col-span-5">
              <Reveal>
                <p className="eyebrow">The Sort of Place</p>
              </Reveal>
              <Reveal delay={120}>
                <h2 className="mt-5 font-heading text-3xl leading-[1.05] text-foreground-950 md:text-4xl">
                  Send Eddie{" "}
                  <span className="italic text-primary-600">somewhere real.</span>
                </h2>
              </Reveal>
              <Reveal delay={200}>
                <p className="mt-6 max-w-md font-body text-base leading-relaxed text-foreground-700">
                  The best recommendations come from people who live there.
                  Tell us what makes your place worth the journey.
                </p>
              </Reveal>

              <div className="mt-9 flex flex-col gap-4">
                {prompts.map((p, i) => (
                  <Reveal key={p} delay={240 + i * 60}>
                    <div className="flex items-start gap-3">
                      <i className="ri-map-pin-2-line mt-0.5 text-primary-500" />
                      <p className="font-body text-sm leading-relaxed text-foreground-700">
                        {p}
                      </p>
                    </div>
                  </Reveal>
                ))}
              </div>
            </div>

            <div className="lg:col-span-6 lg:col-start-7">
              <Reveal delay={120}>
                <LocavoreForm />
              </Reveal>
            </div>
          </div>
        </div>
      </section>
    </SiteLayout>
  );
}